import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"

const Author = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
        }
      }
    }
  `)
  return (
    <section className="p-entry__author c-bottomSection">
      <h2 className="c-bottomSection__title">この記事を書いた人 </h2>
      <div className="p-authorBox">
        <figure className="p-authorBox__avatar">
          <StaticImage
            src="../images/profile.png"
            alt={data.site.siteMetadata.author}
            className="avatar avatar-100 photo"
            height={100}
            width={100}
            loading="lazy"
            decoding="async"
          />
        </figure>
        <div className="p-authorBox__body">
          <span className="p-authorBox__name">
            {data.site.siteMetadata.author}
          </span>
          <p className="p-authorBox__description u-color-thin">
            27歳でフランスに語学留学、30歳でワーホリ。現在は貿易関係の仕事をしながらフランス語の翻訳や通訳も時々やっている、末端の仏語学習者です。
          </p>
        </div>
      </div>
    </section>
  )
}

export default Author
